// Ohio Counties Data
// Format: [County Name, SVG Path ID, Zip Codes (comma-separated)]
export const OHIO_COUNTIES = [
  ["Adams", "Path_64", ""],
  ["Allen", "Path_86", ""],
  ["Ashland", "Path_22", ""],
  ["Ashtabula", "Path_3", ""],
  ["Athens", "Path_51", ""],
  ["Auglaize", "Path_87", ""],
  ["Belmont", "Path_11", ""],
  ["Brown", "Path_65", ""],
  ["Butler", "Path_91", ""],
  ["Carroll", "Path_13", ""],
  ["Champaign", "Path_81", ""],
  ["Clark", "Path_80", ""],
  ["Clermont", "Path_66", ""],
  ["Clinton", "Path_89", ""],
  ["Columbiana", "Path_10", ""],
  ["Coshocton", "Path_30", ""],
  ["Crawford", "Path_41", ""],
  ["Cuyahoga (West)", "Path_16", "44017, 44070, 44105, 44107, 44109, 44111, 44113, 44115, 44116, 44125, 44126, 44129, 44130, 44131, 44133, 44134, 44135, 44136, 44138, 44140, 44141, 44142, 44145, 44147, 44149, 44181, 44188, 44190, 44193, 44194, 44197, 44198"],
  ["Cuyahoga (Central)", "Path_16-2", "44101, 44102, 44103, 44014, 44106, 44108, 44110, 44112, 44114, 44118, 44120, 44121, 44122, 44127, 44128, 44137, 44144, 44199, 44191, 44192, 44195"],
  ["Cuyahoga (East)", "Path_16-3", "44022, 44040, 44090, 44117, 44119, 44123, 44124, 44132, 44139, 44143, 44146"],
  ["Darke", "Path_88", ""],
  ["Defiance", "Path_76", ""],
  ["Delaware", "Path_38", ""],
  ["Erie", "Path_40", ""],
  ["Fairfield", "Path_32", ""],
  ["Fayette", "Path_60", ""],
  ["Franklin (West)", "Path_39", "43002, 43016, 43017, 43026, 43064, 43065, 43085, 43119, 43123, 43216, 43140, 43146, 43194, 43195, 43199, 43201, 43202, 43203, 43204, 43210, 43211, 43212, 43214, 43215, 43216, 43217, 43218, 43220, 43221, 43222, 43223, 43226, 43227, 43228, 43234, 43235, 43236, 43251, 43260, 43266, 43268, 43271, 43272, 43279, 43287, 43291"],
  ["Franklin (East)", "Path_39-2", "43004, 43054, 43062, 43068, 43069, 43081, 43086, 43109, 43110, 43125, 43137, 43205, 43206, 43207, 43209, 43213, 43219, 43224, 43229, 43230, 43231, 43232, 43270"],
  ["Fulton", "Path_69", ""],
  ["Gallia", "Path_54", ""],
  ["Geauga", "Path_4", ""],
  ["Greene", "Path_85", ""],
  ["Guernsey", "Path_25", ""],
  ["Hamilton (West)", "Path_92", "45001, 45002, 45030, 45033, 45039, 45041, 45051, 45052, 45211, 45214, 45215, 45216, 45217, 45218, 45219, 45220, 45221, 45222, 45223, 45224, 45225, 45229, 45231, 45232, 45233, 45234, 45235, 45237, 45238, 45239, 45240, 45246, 45247, 45248, 45251, 45252, 45253, 45258, 45267, 45268, 45274, 45296"],
  ["Hamilton (East)", "Path_93", "45014, 45069, 45111, 45140, 45174, 45201, 45202, 45203, 45204, 45205, 45206, 45207, 45208, 45209, 45212, 45213, 45226, 44227, 45230, 45236, 45241, 45242, 45243, 45244, 45249, 45250, 45255, 45254, 45262, 45263, 45264, 45269, 45270, 45271, 45273, 45280, 45298, 45299"],
  ["Hancock", "Path_49", ""],
  ["Hardin", "Path_79", ""],
  ["Harrison", "Path_12", ""],
  ["Henry", "Path_71", ""],
  ["Highland", "Path_61", ""],
  ["Hocking", "Path_56", ""],
  ["Holmes", "Path_21", ""],
  ["Huron", "Path_42", ""],
  ["Jackson", "Path_55", ""],
  ["Jefferson", "Path_8", ""],
  ["Knox", "Path_36", ""],
  ["Lake", "Path_5", ""],
  ["Lawrence", "Path_62", ""],
  ["Licking", "Path_35", ""],
  ["Logan", "Path_82", ""],
  ["Lorain", "Path_18", ""],
  ["Lucas", "Path_70", ""],
  ["Madison", "Path_78", ""],
  ["Mahoning", "Path_2", ""],
  ["Marion", "Path_47", ""],
  ["Medina", "Path_17", ""],
  ["Meigs", "Path_53", ""],
  ["Mercer", "Path_77", ""],
  ["Miami", "Path_84", ""],
  ["Monroe", "Path_9", ""],
  ["Montgomery", "Path_67", ""],
  ["Morgan", "Path_28", ""],
  ["Morrow", "Path_37", ""],
  ["Muskingum", "Path_31", ""],
  ["Noble", "Path_26", ""],
  ["Ottawa", "Path_45", ""],
  ["Paulding", "Path_75", ""],
  ["Perry", "Path_29", ""],
  ["Pickaway", "Path_57", ""],
  ["Pike", "Path_58", ""],
  ["Portage", "Path_6", ""],
  ["Preble", "Path_68", ""],
  ["Putnam", "Path_74", ""],
  ["Richland", "Path_23", ""],
  ["Ross", "Path_59", ""],
  ["Sandusky", "Path_46", ""],
  ["Scioto", "Path_63", ""],
  ["Seneca", "Path_43", ""],
  ["Shelby", "Path_83", ""],
  ["Stark", "Path_15", ""],
  ["Summit", "Path_7", ""],
  ["Trumbull", "Path_1", ""],
  ["Tuscarawas", "Path_14", ""],
  ["Union", "Path_44", ""],
  ["Van Wert", "Path_72", ""],
  ["Vinton", "Path_52", ""],
  ["Warren", "Path_90", ""],
  ["Washington", "Path_27", ""],
  ["Wayne", "Path_20", ""],
  ["Williams", "Path_73", ""],
  ["Wood", "Path_50", ""],
  ["Wyandot", "Path_48", ""]
];

// Contact Information
export const CONTACT_INFO = {
  phone: '1-833-711-0773',
  tty: '711',
  hours: 'Monday through Friday, 7 a.m. to 8 p.m., ET'
};

// CSV Configuration
export const CME_DATA_PATH = '/CMEs.csv';
